import localBlogPosts from "../data/localBlogPosts.json";
import { isRedirectedBlogSlug } from "./blogIndexPolicy";

function asList(posts) {
  return Array.isArray(posts) ? posts : [];
}

function normalizeTagList(tags) {
  if (!Array.isArray(tags)) return [];
  return tags
    .map((t) => {
      if (t == null) return null;
      if (typeof t === "string") return { name: t };
      if (t.name) return t;
      return null;
    })
    .filter(Boolean);
}

/** Direct URL preview includes drafts; listing/sitemap should not. */
export function getLocalBlogPost(slug) {
  const key = String(slug || "").trim();
  if (!key) return null;
  const row = asList(localBlogPosts).find((p) => p && p.slug === key);
  if (!row) return null;
  return { ...row, tags: normalizeTagList(row.tags) };
}

export function getPublishedLocalBlogPosts() {
  return asList(localBlogPosts)
    .filter((p) => p && p.slug && !p.draft)
    .map((p) => ({ ...p, tags: normalizeTagList(p.tags) }));
}

/**
 * Local markdown posts fill slugs WISP does not have yet.
 * If both exist, WISP wins so a later CMS publish stays canonical.
 */
export function mergeWispWithLocal(wispPosts) {
  const bySlug = new Map();
  for (const p of getPublishedLocalBlogPosts()) {
    bySlug.set(p.slug, p);
  }
  for (const p of asList(wispPosts)) {
    const slug = p?.slug;
    if (!slug || isRedirectedBlogSlug(slug)) continue; // retired: 308 at the edge
    bySlug.set(slug, p);
  }
  return [...bySlug.values()].sort((a, b) => {
    const da = Date.parse(a.publishedAt || a.createdAt || 0) || 0;
    const db = Date.parse(b.publishedAt || b.createdAt || 0) || 0;
    return db - da;
  });
}
